import { getLocalStorageItem, resetLocalStorageItem, setLocalStorageItem } from "./local-storage";

const KEY_QUERYID = "algoliaSearchQueryID";
const KEY_OBJECTDATA = "algoliaSearchObjectData";

export const saveQueryID = (id: string | undefined) => {
	if (!id) {
		resetLocalStorageItem(KEY_QUERYID);
		return;
	}
	setLocalStorageItem<string>(KEY_QUERYID, id);
};

export const readQueryID = (): string | undefined => {
	return getLocalStorageItem<string>(KEY_QUERYID);
};

type objectData = {
	objectID: string;
	queryID: string;
};

export const saveObjectID = ({ objectID, queryID }: objectData) => {
	if (!objectID || !queryID) return;

	const objectData = readObjectData();

	if (objectData.some((product) => product.objectID === objectID)) {
		return;
	}

	const updatedProducts = [...objectData, { objectID, queryID }];
	setLocalStorageItem<objectData[]>(KEY_OBJECTDATA, updatedProducts);
};

export const readObjectData = () => {
	return getLocalStorageItem<objectData[]>(KEY_OBJECTDATA) || [];
};

export const resetObjectData = () => {
	resetLocalStorageItem(KEY_OBJECTDATA);
};
